module.exports = __webpack_public_path__ + "img/rvspijpstukken.df272128.jpg";